import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfigService } from '../../../../../../../services/organization-config/organization-config.service';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../utils';


@Component({
  selector: 'app-set-mailchimp-audience-modal',
  templateUrl: './set-mailchimp-audience-modal.component.html',
  styleUrls: ['./set-mailchimp-audience-modal.component.css']
})
export class SetMailchimpAudienceModalComponent implements OnInit {
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public audiences: {id: string, name: string}[];
  public selectedAudience: {id: string, name: string} = null;
  public syncFromMailchimp = null;
  public hasConfirmed = false;

  public loadingAudiences = true;
  public loadingSave = false;

  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfigService: OrganizationConfigService
  ) {
  }

  ngOnInit() {
    this.loadAudiences();
  }

  public handleSubmit() {
    if (!this.canSave()) { return; }

    this.loadingSave = true;

    this.orgConfigService
      .setMailchimpAudience(
        this.selectedAudience.id,
        this.syncFromMailchimp
      )
      .then(() => {
        let successText = '';
        if (this.syncFromMailchimp) {
          successText = 'Mailchimp audience update in progress. This may take several minutes to complete.';
        } else {
          successText = 'Mailchimp audience updated successfully.';
        }

        this.savedCallback({
          text: successText,
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingSave = false; });
  }

  public canSave() {
    return (
      (this.selectedAudience !== null) &&
      (this.syncFromMailchimp !== null) &&
      this.hasConfirmed
    );
  }

  private loadAudiences() {
    this.loadingAudiences = true;

    this.orgConfigService
      .getMailchimpAudiences()
      .then(response => {
        this.audiences = response;
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingAudiences = false; });
  }

}
